// @flow
import { select, call } from 'redux-saga/effects';
import { getHoneycombEndpoint, getToken } from '~/core/state/application/selectors';
import type { Effect } from 'redux-saga';

export const setupHeaders = (token: string) => {
    const headers: Object = {
        'Content-Type': 'application/json',
        'X-AlertMe-Client': 'Honeycomb Webapp',
        Accept: `application/vnd.alertme.zoo-6.5+json`
    };

    if (token.length > 64) {
        headers['Authorization'] = `Bearer ${token}`;
    } else {
        headers['X-Omnia-Access-Token'] = token;
    }

    return headers;
};

export function* getSenseMedia(id: string): Generator<Effect, *, *> {
    const endpoint: string = yield select(getHoneycombEndpoint);
    const token: string = yield select(getToken);
    const headers = setupHeaders(token);

    return yield call(fetch, `${endpoint}/omnia/media/${id}`, { headers });
}

export function* flagSenseMedia(id: string, flag: boolean): Generator<Effect, *, *> {
    const endpoint: string = yield select(getHoneycombEndpoint);
    const token: string = yield select(getToken);
    const headers = setupHeaders(token);

    return yield call(fetch, `${endpoint}/omnia/media/${id}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({
            media: [
                {
                    flagged: true
                }
            ]
        })
    });
}

export function* deleteSenseMedia(id: string): Generator<Effect, *, *> {
    const endpoint: string = yield select(getHoneycombEndpoint);
    const token: string = yield select(getToken);
    const headers = setupHeaders(token);

    return yield call(fetch, `${endpoint}/omnia/media/${id}`, { method: 'DELETE', headers });
}



// WEBPACK FOOTER //
// ./src/core/api/honeycomb/index.js